import { render, staticRenderFns } from "./tcustsubaccount.vue?vue&type=template&id=5499ab66&"
import script from "./tcustsubaccount.vue?vue&type=script&lang=js&"
export * from "./tcustsubaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports